export default __webpack_public_path__ + "5c2d3d35ed84abab5ffb05e773d6e78c.png";